import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import CavityPump from 'features/processFlowDiagrams/svg/pumps/cavity-pump.svg?react'
import CentrifugalPump1 from 'features/processFlowDiagrams/svg/pumps/centrifugal-pump-1.svg?react'
import CentrifugalPump2 from 'features/processFlowDiagrams/svg/pumps/centrifugal-pump-2.svg?react'
import CentrifugalPump3 from 'features/processFlowDiagrams/svg/pumps/centrifugal-pump-3.svg?react'
import FeedPump from 'features/processFlowDiagrams/svg/pumps/feed-pump.svg?react'
import GasBlower from 'features/processFlowDiagrams/svg/pumps/gas-blower.svg?react'
import GasCompressor from 'features/processFlowDiagrams/svg/pumps/gas-compressor.svg?react'
import GearPump from 'features/processFlowDiagrams/svg/pumps/gear-pump.svg?react'
import HorizontalPump from 'features/processFlowDiagrams/svg/pumps/horizontal-pump.svg?react'
import Injector from 'features/processFlowDiagrams/svg/pumps/injector.svg?react'
import Peristaltic from 'features/processFlowDiagrams/svg/pumps/peristaltic.svg?react'
import ScrewPump from 'features/processFlowDiagrams/svg/pumps/screw-pump.svg?react'
import ScrewPump2 from 'features/processFlowDiagrams/svg/pumps/screw-pump-2.svg?react'
import SubmersiblePump from 'features/processFlowDiagrams/svg/pumps/submersible-pump.svg?react'
import SumpPump from 'features/processFlowDiagrams/svg/pumps/sump-pump.svg?react'
import Turbine from 'features/processFlowDiagrams/svg/pumps/turbine.svg?react'
import VacuumPump from 'features/processFlowDiagrams/svg/pumps/vacuum-pump.svg?react'
import VerticalPump from 'features/processFlowDiagrams/svg/pumps/vertical-pump.svg?react'
import React from 'react'

export const PID_PUMPS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'cavity-pump',
    name: 'Cavity Pump',
    category: 'pumps',
    svgContent: <CavityPump />,
    viewBox: '0 0 123 35',
  },
  {
    id: 'centrifugal-pump-1',
    name: 'Centrifugal Pump 1',
    category: 'pumps',
    svgContent: <CentrifugalPump1 />,
    viewBox: '0 0 70 67',
  },
  {
    id: 'centrifugal-pump-2',
    name: 'Centrifugal Pump 2',
    category: 'pumps',
    svgContent: <CentrifugalPump2 />,
    viewBox: '0 0 62 77',
  },
  {
    id: 'centrifugal-pump-3',
    name: 'Centrifugal Pump 3',
    category: 'pumps',
    svgContent: <CentrifugalPump3 />,
    viewBox: '0 0 70 67',
  },
  {
    id: 'feed-pump',
    name: 'Feed Pump',
    category: 'pumps',
    svgContent: <FeedPump />,
    viewBox: '0 0 100 40',
  },
  {
    id: 'gas-blower',
    name: 'Gas Blower',
    category: 'pumps',
    svgContent: <GasBlower />,
    viewBox: '0 0 72 67',
  },
  {
    id: 'gas-compressor',
    name: 'Gas Compressor',
    category: 'pumps',
    svgContent: <GasCompressor />,
    viewBox: '0 0 100 55',
  },
  {
    id: 'gear-pump',
    name: 'Gear Pump',
    category: 'pumps',
    svgContent: <GearPump />,
    viewBox: '0 0 57 91',
  },
  {
    id: 'horizontal-pump',
    name: 'Horizontal Pump',
    category: 'pumps',
    svgContent: <HorizontalPump />,
    viewBox: '0 0 155 111',
  },
  {
    id: 'injector',
    name: 'Injector',
    category: 'pumps',
    svgContent: <Injector />,
    viewBox: '0 0 80 40',
  },
  {
    id: 'peristaltic',
    name: 'Peristaltic',
    category: 'pumps',
    svgContent: <Peristaltic />,
    viewBox: '0 0 60 69',
  },
  {
    id: 'screw-pump',
    name: 'Screw Pump',
    category: 'pumps',
    svgContent: <ScrewPump />,
    viewBox: '0 0 70 66',
  },
  {
    id: 'screw-pump-2',
    name: 'Screw Pump 2',
    category: 'pumps',
    svgContent: <ScrewPump2 />,
    viewBox: '0 0 123 40',
  },
  {
    id: 'submersible-pump',
    name: 'Submersible Pump',
    category: 'pumps',
    svgContent: <SubmersiblePump />,
    viewBox: '0 0 103 74',
  },
  {
    id: 'sump-pump',
    name: 'Sump Pump',
    category: 'pumps',
    svgContent: <SumpPump />,
    viewBox: '0 0 103 186',
  },
  {
    id: 'turbine',
    name: 'Turbine',
    category: 'pumps',
    svgContent: <Turbine />,
    viewBox: '0 0 98 60',
  },
  {
    id: 'vacuum-pump',
    name: 'Vacuum Pump',
    category: 'pumps',
    svgContent: <VacuumPump />,
    viewBox: '0 0 99 49',
  },
  {
    id: 'vertical-pump',
    name: 'Vertical Pump',
    category: 'pumps',
    svgContent: <VerticalPump />,
    viewBox: '0 0 120 146',
  },
]
